import { scrollTop } from "@helpers/dom.js";
import controller from "@js/controller/controller.js";
import model from "@js/model.js";
import Enum from "@shared/enum.js";

export default function(){
    if(model.isView(Enum.Views.MAIN)){
        controller.gotoCategory({level1: model.categories.level1[0].id}, {forceScroll: false}); 
        !model.isUI('FUND') && scrollTop(0);
        return;
    }

    location.assign(model.urls.homepage);
}